import { FC } from "react"
import { useLogout } from "../../hooks"
import { Button, BBModal } from "../../ui"

interface SessionExpiredModalProps {
  isOpen: boolean
}

const SessionExpiredModal: FC<SessionExpiredModalProps> = ({ isOpen }) => {
  const handleLogout = useLogout()

  return (
    <BBModal show={isOpen} title="Session Expired" showCloseButton={false}>
      <div className="mt-2">
        <p className="text-sm text-gray-500">
          Your session has expired. Please log in again to continue.
        </p>
      </div>

      <div className="mt-4">
        <Button onClick={handleLogout} className="w-full">
          Go to Login Page
        </Button>
      </div>
    </BBModal>
  )
}

export default SessionExpiredModal
